import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ContractingAddPage from './pages/ContractingAddPage';
import ContractingsSection from './sections/ContractingsSection';
import ContractingDetailPage from './pages/ContractingDetailPage';
import ContractingPreparePage from './pages/ContractingPreparePage';

const Contracting = () => {
  const { t } = useTranslation("shared\\moduleNames");
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/prepare/:commodity`} component={ContractingPreparePage}/>
      <Route path={`${match.path}/add`} component={ContractingAddPage}/>
      <Route path={`${match.path}/:contractingId`} component={ContractingDetailPage} />
      <Route path={match.path}>
        <Header title={t("contracting.title")} includeBreadcrumbs />
        <ModuleContent>
          <ContractingsSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
}

export default Contracting;